import { HamiltonProductReduced } from '../../api/products-api';
import { addItemToShoppingCart } from '../../api/shopping-cart-api';
import { currentBreakpoint } from '../../utils/resize.utils';
import { toastNotification } from '../toast-notification/toast-notification.module';
import { shoppingCart } from '../shopping-cart/shopping-cart.module';

/**
 * Function to add the given product to the shopping cart.
 * @param product The product to add
 * @param labelAddToShoppingCart Label for "add to shopping cart"
 * @param labelGoToShoppingCart Label for "go to shopping cart"
 * @param errorMessage Message to display if an error occurs.
 */
export const addToShoppingCart = (
  product: HamiltonProductReduced,
  labelAddToShoppingCart: string,
  labelGoToShoppingCart: string,
  errorMessage: string
): void => {
  // add selected item to the shopping cart
  addItemToShoppingCart(product.nodeid).then((success) => {
    if (success) {
      const breakpoint = currentBreakpoint();
      if (breakpoint.isMobilePortrait || breakpoint.isMobileLandscape) {
        // on mobile show a toast
        toastNotification.createMobileToast(product, labelAddToShoppingCart, labelGoToShoppingCart, () => {
          shoppingCart.openShoppingCart();
        });
      } else {
        // Show toastify toast on desktop
        toastNotification.createDesktopToast(product, labelAddToShoppingCart);
        // reload the shopping cart if it is open
        shoppingCart.reloadShoppingCart();
      }
    } else {
      toastNotification.createErrorToastMessage(errorMessage);
    }
  });
};
